import { useEffect, useState } from "react";
import { TableGeneral } from "../../../components/table/TableGeneral";
import { useLeadersTable } from "../../../hooks/useLeadersTable";

export const LeadersTable = ({ leaderProjects = [] }) => {
	const [leaders, setLeaders] = useState([]);
	const { columns } = useLeadersTable();

	useEffect(() => {
		setLeaders(() => {
			return leaderProjects.map(({ name, color, total, sizes }) => {
				const projectSizes = sizes.reduce((projectSizes, size) => {
					return {
						...projectSizes,
						[size.name]: size.total,
					};
				}, {});
				return {
					key: name,
					name,
					color,
					project: total,
					...projectSizes,
				};
			});
		});
	}, [leaderProjects]);

	const tableProps = {
		scroll: { x: 1400, y: null },
		className: "showHeader",
	};

	return <TableGeneral column={columns} state={leaders} tableProps={tableProps} />;
};
